var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackground = function SvgBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1170 780"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_90970)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2476_90970)",
    d: "m-269.787 167.415 616.558 355.763 480.023-276.949-1096.581-632.498v553.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_2476_90970)",
    d: "M-269.787 642.48c0 105.233 113.994 170.847 205.005 118.221L346.753 523.16-270 167.415v474.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_2476_90970)",
    d: "M1101.37-148.728-64.765-821.484c-91.241-52.625-205.022 13.201-205.022 118.222v316.993L826.776 246.212 1101.56 87.715c91.25-52.625 91.25-184.047 0-236.443h-.21z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2476_90970",
    x1: -664.227,
    x2: 1016.98,
    y1: -353.595,
    y2: 647.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2476_90970",
    x1: -977.994,
    x2: 421.082,
    y1: -16.863,
    y2: 862.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2476_90970",
    x1: -292.061,
    x2: 2576.59,
    y1: -693.588,
    y2: 1035.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_90970"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-270-840h1440V779.25H-270z"
  })))));
};
export default SvgBackground;